/**
 * Created by Olga Eremina on 19.10.2026
 */

const RemoveHintLogic = {
    type: "remove",
    priority: 3,

    findMove: function () {
        if (!Merge2.current || !Merge2.current.isGameMode() || Merge2.current.field.countEmptySlots() > 0) {
            return;
        }

        const target = this.findRemoveButton() || this.findUnitView();
        if (!target) {
            return;
        }

        return {
            type: RemoveHintLogic.type,
            delay: 3000,
            interval: 3000,
            target
        };
    },

    findRemoveButton: function () {
        const selected = Merge2.current.field.selectedUnit;
        if (!selected || !selected.isSellable() || selected.customerMark) {
            return;
        }

        const unitInfoView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).unitInfoView;
        return ComponentUtils.findComponentByName(unitInfoView, "UnitInfoViewController").getRemoveButton();
    },

    findUnitView: function () {
        const unit = Merge2.current.field.findUnitToRemove();
        return unit && unit.onGetView();
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(RemoveHintLogic);
